function roundUpNearest10(num) {
  return Math.ceil(num / 10) * 10;
}

class TruncatedText extends HTMLElement {

  constructor() {
    super();
    this.toggleTemplate = this.querySelector('[data-template-toggle]');
    this.btn = this.toggleTemplate.content.cloneNode(true);
    this.appendChild(this.btn);
    this.btn = this.querySelector('[data-toggle]');
    this.content = this.querySelector('[data-content]');
    this.btn.addEventListener('click', this.onButtonClick.bind(this));

    this.truncateText();
  }

  truncateText() {
    const computedStyleContentParagraph = window.getComputedStyle(this.content.querySelector('p'));

    const paragraphFontSize = computedStyleContentParagraph.fontSize;
    const paragraphLineHeight = computedStyleContentParagraph.lineHeight;

    const lineHeightInteger = parseInt(paragraphLineHeight.replace('px', ''));
    const minLines = 4;
    
    this.minHeightToTruncate = lineHeightInteger * minLines;

    const contentHeight = this.content.clientHeight;

    if (contentHeight > this.minHeightToTruncate) {
      this.content.style.setProperty('--sh', `${this.minHeightToTruncate}px`);
      this.content.setAttribute('data-truncated', '');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.content.hasAttribute('data-open')) {
      this.content.style.setProperty('--sh', `${this.minHeightToTruncate}px`);
      this.btn.setAttribute('aria-expanded', false);
      this.btn.querySelector('[data-i18n-read-more]').removeAttribute('hidden');
      this.btn.querySelector('[data-i18n-read-less]').setAttribute('hidden', '');
      setTimeout(() => {
        this.content.removeAttribute('data-open');
      }, 300);
    } else {
      this.content.style.setProperty('--sh', `${this.content.scrollHeight}px`);
      this.btn.setAttribute('aria-expanded', true);
      this.btn.querySelector('[data-i18n-read-more]').setAttribute('hidden', '');
      this.btn.querySelector('[data-i18n-read-less]').removeAttribute('hidden');
      setTimeout(() => {
        this.content.setAttribute('data-open', '');
      }, 300);
    }
  }

}

customElements.define('truncated-text', TruncatedText);